import { useEffect, useRef } from 'react';
import classes from './IframeInput.module.scss';
import ButtonSend from '../../ButtonSend';

export default function IframeInput(props) {

    const { onChangeHandler, inputValue, inputDisabled, isInputEmpty, soundInputHandler } = props;
    const inputRef = useRef();

    useEffect(() => {
        setTimeout(() => {
            inputRef.current?.focus();
        });
    }, [])

    return (
        <div className={classes.iframeContainer} >
            <input type="text" onChange={onChangeHandler} name='options' ref={inputRef} className={classes.inputIframe} value={inputValue} disabled={inputDisabled} onKeyDown={soundInputHandler} />
            <div className={classes.actions}>
                <ButtonSend
                    className={classes.sendButtonIframe}
                    disabled={isInputEmpty || inputDisabled}
                />
            </div>
        </div>
    )
}